<template>
  <div class="rd-anchor rd-menu">
    <button
      type="button"
      class="rd-btn rd-btn--sm"
      :class="{ 'rd-btn--acc': partial }"
      aria-haspopup="dialog"
      :aria-expanded="String(open)"
      :aria-label="label"
      :disabled="!items.length"
      @click="toggle"
    >
      <v-icon size="16">{{ icon }}</v-icon>
      <span class="rd-menu__label">{{ label }}</span>
      <b v-if="partial" class="rd-num">{{ selectedCount }}/{{ items.length }}</b>
      <v-icon size="16">mdi-chevron-down</v-icon>
    </button>

    <div v-if="open" ref="popover" class="rd-pop rd-pop--menu" role="dialog" tabindex="-1" :aria-label="label">
      <div class="rd-pop__head">
        <span>{{ label }}</span>
        <span class="rd-num">{{ selectedCount }}/{{ items.length }}</span>
      </div>
      <div class="rd-checklist" role="group" :aria-label="label">
        <label v-for="item in items" :key="item.value">
          <input type="checkbox" :checked="value.includes(item.value)" @change="toggleItem(item.value)" />
          <span :title="item.text">{{ item.text }}</span>
        </label>
      </div>
      <div class="rd-pop__links">
        <button type="button" class="rd-link-btn" @click="$emit('input', items.map((item) => item.value))">
          {{ $t("report_mobile.all") }}
        </button>
        <button type="button" class="rd-link-btn rd-pop__done" @click="close(true)">
          {{ $t("report_desktop.done") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Dugme sa iskačućim spiskom kvačica u traci alata ekrana (npr. kolone tabele ili grupe jela). Ne drži izbor:
 * dobija `value` (niz izabranih vrednosti) i javlja `input`.
 */
export default {
  name: "ReportChecklistMenu",
  props: {
    label: { type: String, required: true },
    /** [{ value, text }] */
    items: { type: Array, default: () => [] },
    value: { type: Array, default: () => [] },
    icon: { type: String, default: "mdi-view-column-outline" },
  },
  data: () => ({
    open: false,
  }),
  computed: {
    selectedCount() {
      return this.items.filter((item) => this.value.includes(item.value)).length;
    },
    partial() {
      return this.items.length > 0 && this.selectedCount < this.items.length;
    },
  },
  mounted() {
    document.addEventListener("mousedown", this.onOutside);
    this.$el.addEventListener("keydown", this.onKeydown);
  },
  beforeDestroy() {
    document.removeEventListener("mousedown", this.onOutside);
  },
  methods: {
    toggle() {
      this.open = !this.open;
      if (this.open) {
        this.$nextTick(() => this.$refs.popover?.focus());
      }
    },
    close(restoreFocus = false) {
      if (!this.open) {
        return;
      }
      this.open = false;
      if (restoreFocus) {
        this.$nextTick(() => this.$el.querySelector("button")?.focus());
      }
    },
    toggleItem(value) {
      const next = this.value.includes(value)
        ? this.value.filter((item) => item !== value)
        : [...this.value, value];
      // redosled stavki ostaje kao u spisku
      this.$emit(
        "input",
        this.items.map((item) => item.value).filter((item) => next.includes(item))
      );
    },
    onOutside(event) {
      if (this.open && !this.$el.contains(event.target)) {
        this.close();
      }
    },
    onKeydown(event) {
      if (event.key === "Escape" && this.open) {
        event.stopPropagation();
        this.close(true);
      }
    },
  },
};
</script>
